import React from "react";
import { X } from "lucide-react";
import ProductCampaignsPanel from "./ProductCampaignsPanel";
import ProductSearchHistoryPanel from "./ProductSearchHistoryPanel";

const ProductDashboardSidePanel = ({
    mode,
    product,
    organizationId,
    onClose,
    onViewCampaign,
    onStartCampaignForSearch,
}) => {
    if (!product || !mode) return null;

    const isSearchHistory = mode === "search-history";

    return (
        <aside className="app-panel-slide-right flex h-[36rem] max-h-[82vh] min-h-0 w-full min-w-0 flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm lg:h-full lg:max-h-none">
            <header className="flex shrink-0 items-start justify-between gap-3 border-b border-indigo-100 bg-[#eef2ff] p-4">
                <div className="min-w-0">
                    <h2 className="text-lg font-semibold text-[#0f172a]">
                        {isSearchHistory
                            ? "Select a Search"
                            : "Campaigns Using This Product"}
                    </h2>
                    <p className="mt-1 text-sm text-[#475569]">
                        {isSearchHistory
                            ? "Choose a search to create a campaign for the selected product."
                            : "View details of the campaign"}
                    </p>
                </div>
                <button
                    type="button"
                    onClick={onClose}
                    aria-label="Close side panel"
                    title="Close"
                    className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-slate-500 transition hover:bg-indigo-50 hover:text-indigo-700"
                >
                    <X size={19} aria-hidden="true" />
                </button>
            </header>

            <div className="product-scrollbar min-h-0 flex-1 overflow-y-auto">
                {isSearchHistory ? (
                    <ProductSearchHistoryPanel
                        product={product}
                        onStartCampaignForSearch={onStartCampaignForSearch}
                    />
                ) : (
                    <ProductCampaignsPanel
                        product={product}
                        organizationId={organizationId}
                        onViewCampaign={onViewCampaign}
                    />
                )}
            </div>
        </aside>
    );
};

export default ProductDashboardSidePanel;
